module.exports = __webpack_public_path__ + "static/customisable-search-7127f47c38578afee6163bd8359bffc0.png";